import { React, useState, useEffect } from "react";
import { Modal } from "@mui/material";
import Swal from "sweetalert2";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { LoaderScreen } from "../../components/LoaderScreen";
import { URL } from "../../../Helpers/Accesos";

const CargarHtmlModal = ({ open, onClose, presentacionId }) => {
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });
    const [htmlContenido, setHtmlContenido] = useState("");

    useEffect(() => {
        if (!open) setHtmlContenido("");
    }, [open]);

    const validar = () => {
        if (!htmlContenido.trim()) {
            Swal.fire({
                title: "PRESENTACIONES",
                text: "El contenido HTML es requerido",
                icon: "warning",
                customClass: { container: "mi-superpoop" },
            });
            return false;
        }
        return true;
    };

    const handleGuardar = () => {
        if (!validar()) return;
        setLoader({ ...loader, mostrar: true });

        const body = {
            presentacionId: presentacionId,
            htmlContenido: htmlContenido,
            usuario: 0,
        };

        const token = localStorage.getItem("HumayaDigital-Token");
        fetch(`${URL}Presentacion/GuardarHtml`, {
            method: "POST",
            body: JSON.stringify(body),
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        })
            .then(async (result) => {
                const data = await result.json();
                if (result.ok) {
                    setLoader({ ...loader, mostrar: false });
                    await Swal.fire({
                        title: "PRESENTACIONES",
                        text: "HTML cargado con éxito",
                        icon: "success",
                        customClass: { container: "mi-superpoop" },
                    });
                    handleCancelar();
                } else {
                    setLoader({ ...loader, mostrar: false });
                    Swal.fire("PRESENTACIONES", JSON.stringify(data), "error");
                }
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("PRESENTACIONES", JSON.stringify(error), "error");
            });
    };

    const handleArchivoHtml = ({ target }) => {
        const file = target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = (e) => setHtmlContenido(e.target.result);
        reader.readAsText(file);
        target.value = "";
    };

    const handleCancelar = () => {
        setHtmlContenido("");
        onClose();
    };

    return (
        <Modal open={open} onClose={handleCancelar}>
            <div className="cargar-html-modal-formulario">
                <div className="cargar-html-modal-plantilla">
                    <div className="plantilla-screen-filtro-container" id="cargar-html-modal">
                        <PlantillaScreen
                            titulo="CARGAR HTML"
                            className_main={1}
                            className="plantilla-screen-filtro-container-modal"
                        >
                            <div className="cerrar-modal-button" onClick={handleCancelar}>X</div>
                            <LoaderScreen loader={loader} />
                            <div className="cargar-html-modal-content">
                                <div className="cargar-html-modal-content-container scroll-4">
                                    <div className="pres-form-group">
                                        <label>Cargar archivo HTML</label>
                                        <input
                                            type="file"
                                            accept=".html,.htm"
                                            onChange={handleArchivoHtml}
                                            className="pres-file-input"
                                        />
                                    </div>
                                    <div className="pres-form-group">
                                        <label>Contenido HTML</label>
                                        <textarea
                                            value={htmlContenido}
                                            onChange={(e) => setHtmlContenido(e.target.value)}
                                            placeholder="Pega o escribe el contenido HTML aquí..."
                                            className="pres-html-textarea"
                                            spellCheck={false}
                                        />
                                    </div>
                                </div>
                                <div className="cargar-html-modal-buttons">
                                    <button
                                        className="cargar-html-modal-button-cancelar"
                                        onClick={handleCancelar}
                                    >
                                        Cancelar
                                    </button>
                                    <button
                                        className="cargar-html-modal-button-guardar"
                                        onClick={handleGuardar}
                                        disabled={loader.mostrar}
                                    >
                                        Guardar
                                    </button>
                                </div>
                            </div>
                        </PlantillaScreen>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default CargarHtmlModal;
